import Vue from 'vue';
import store from '@/store';
import Router from 'vue-router';
import Home from '@/views/home/main/Home.vue';
import Login from '@/views/home/main/Login.vue';
import Survey from '@/views/survey/main/Survey.vue';
import Agreement from '@/views/agreement/main/Agreement.vue';
import Composition from '@/views/composition/main/Composition.vue';
import CompositionStep1 from '@/views/composition/main/step1/CompositionStep1.vue';
import CompositionStep2 from '@/views/composition/main/step2/CompositionStep2.vue';
import CompositionStep3 from '@/views/composition/main/step3/CompositionStep3.vue';
import CompositionPayment from '@/views/composition/payment/CompositionPayment.vue';
import CompositionComplete from '@/views/composition/complete/CompositionComplete.vue';
import Mypacks from '@/views/mypacks/main/Mypacks.vue';
import MypackDetail from '@/views/mypacks/detail/MypackDetail.vue';
import MypackConsultation from '@/views/mypacks/consultation/MypackConsultation.vue';
import Order from '@/views/order/main/Order.vue';
import OrderComplete from '@/views/order/complete/OrderComplete.vue';
import Test from '@/views/Test.vue';
import { log } from "@/utils/common";

import { CONTEXT_TYPE } from '@/utils/constants';
import multiguard from 'vue-router-multiguard';
//import authGuard from './auth-guard';
import termGuard from './term-guard';

Vue.use(Router);

const authGuard = (to, from, next) => {

  if (store.getters.userId) {

    const bizNature = store.getters.bizNature;
    if (bizNature === 'AMWAYBUSINESSNATURE_1' || to.path === "/") {
      // logged in
      log('auth-guard::', 'stays logged in');
      next();
    }
    else {
      log('auth-guard::', 'Unauthorized access - Redirecting');
      alert("해당 서비스는 ABO만 사용 가능합니다.");
      next('/');
    }
  }
  else {
    log('auth-guard::', 'NOT logged in');
    window.location.href = `https://${process.env.SSO_HOST}/login`;
  }
};

const router = new Router({
  mode: 'history',
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/survey',
      name: 'survey',
      beforeEnter: authGuard,
      component: Survey,
    },
    {
      path: '/agreement/:type',
      name: 'agreement',
      beforeEnter: authGuard,
      component: Agreement,
    },
    {
      path: '/composition',
      component: Composition,
      children: [
        {
          path: '',
          beforeEnter: multiguard([authGuard, termGuard]),
          component: CompositionStep1,
          props: {
            phase: 1,
          },
        },
        {
          path: 'recomposition',
          meta: {
            requiredContext: [
              CONTEXT_TYPE.RECOMPOSITION,
              CONTEXT_TYPE.RECOMPOSITION_WITH_REQNO,
            ],
          },
          beforeEnter: multiguard([authGuard, termGuard]),
          component: CompositionStep1,
          props: {
            phase: 1,
          },
        },
        {
          path: 'step1',
          meta: {
            requiredContext: [
              CONTEXT_TYPE.COMPOSITION,
              CONTEXT_TYPE.RECOMPOSITION,
              CONTEXT_TYPE.RECOMPOSITION_WITH_REQNO,
            ],
          },
          beforeEnter: multiguard([authGuard, termGuard]),
          component: CompositionStep1,
          props: {
            phase: 1,
          },
        },
        {
          path: 'step2',
          meta: {
            requiredContext: [
              CONTEXT_TYPE.COMPOSITION,
              CONTEXT_TYPE.RECOMPOSITION,
              CONTEXT_TYPE.RECOMPOSITION_WITH_REQNO,
              CONTEXT_TYPE.COMPOSITION_FINAL,
            ],
          },
          beforeEnter: multiguard([authGuard, termGuard]),
          component: CompositionStep2,
          props: {
            phase: 2,
          },
        },
        {
          path: 'step3',
          // meta: {
          //   requiredContext: [CONTEXT_TYPE.REQUEST],
          // },
          beforeEnter: multiguard([authGuard, termGuard]),
          component: CompositionStep3,
          props: {
            phase: 3,
          },
        },
      ],
    },
    {
      path: '/composition/payment',
      name: 'composition-payment',
      beforeEnter: authGuard,
      // beforeEnter: multiguard([authGuard, (to, from, next) => {
      //   if (!(to.params.appliedStateDetail && to.params.productsDetails)) {
      //     next('/');
      //     return;
      //   }
      //   next();
      // }]),
      component: CompositionPayment,
      props: true,
    },
    {
      path: '/composition/complete',
      name: 'composition-complete',
      beforeEnter: multiguard([authGuard, (to, from, next) => {
        if (!(to.params.appliedStateDetail && to.params.productsDetails)) {
          next('/');
          return;
        }
        next();
      }]),
      component: CompositionComplete,
      props: true,
    },

    {
      path: '/mypacks',
      name: 'mypacks',
      beforeEnter: authGuard,
      component: Mypacks,
    },
    {
      path: '/mypacks/:id',
      name: 'mypack-detail',
      beforeEnter: authGuard,
      component: MypackDetail,
    },
    {
      path: '/mypacks/consultation/:id',
      name: 'mypack-consultation',
      beforeEnter: authGuard,
      component: MypackConsultation,
    },
    {
      path: '/order',
      name: 'order',
      beforeEnter: multiguard([authGuard, (to, from, next) => {
        // if (!to.params.orderInfo) {
        //   next('/mypacks');
        //   return;
        // }
        next();
      }]),
      component: Order,
      props: true,
    },
    {
      path: '/order/complete',
      name: 'order-complete',
      beforeEnter: multiguard([authGuard, (to, from, next) => {
        if (!to.params.orderResult) {
          next('/mypacks');
          return;
        }
        next();
      }]),
      component: OrderComplete,
      props: true,
    },
    {
      path: '/test',
      name: 'test',
      beforeEnter: (to, from, next) => {
        if (process.env.NODE_ENV === 'development') {
          next();
        } else {
          next('/');
        }
      },
      component: Test,

    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});

router.beforeEach((to, from, next) => {
  console.log('router::beforeEach', 'before dispatching ssoLogin');
  if (['home', 'login'].includes(to.name)) {
    next();
    return;
  }

  // 마이팩 목록 탭간 이동 시
  if (
    (from.fullPath == "/mypacks" && (to.fullPath == "/mypacks?tab=single" || to.fullPath == "/mypacks?tab=recurring")) ||
    (from.fullPath == "/mypacks?tab=recurring" && to.fullPath == "/mypacks?tab=single") ||
    (from.fullPath == "/mypacks?tab=single" && to.fullPath == "/mypacks?tab=recurring")
  ) {
    next();
    return;
  }
  store.dispatch('ssoLogin');
  store.dispatch("ssoToken");
  store.getters.appReadyState
    .then(() => {
      next();
    });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js